import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { StatisticTimeRange } from '../Enums/StatisticTimeRange.enum';

import { StatisticsSalesVolumeBySupplierColumn } from './StatisticsSalesVolumeBySupplierColumn.entity';

export class StatisticSalesVolumeBySupplier<T extends EMode = EMode.entity> {
  /** Alias: start */
  start?: any;
  /** Alias: end */
  end?: any;
  /** Alias: timeSpanUnit */
  timeSpanUnit?: StatisticTimeRange;
  /** Alias: columnCount */
  columnCount?: any;
  /** Alias: columns */
  columns?: StatisticsSalesVolumeBySupplierColumn<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<StatisticSalesVolumeBySupplier> = {
  start: {
    alias: 'start',
  },
  end: {
    alias: 'end',
  },
  timeSpanUnit: {
    alias: 'timeSpanUnit',
  },
  columnCount: {
    alias: 'columnCount',
  },
  columns: {
    alias: 'columns',
    entity: Entities.statisticsSalesVolumeBySupplierColumn,
  },
  __typename: {
    alias: '__typename',
  },
};

export const statisticSalesVolumeBySupplierEntityDefinition: EntitiyDefinition<StatisticSalesVolumeBySupplier> =
  {
    local: {},
    remote: {
      queryName: 'statisticSalesAmountBySupplier',
      fragmentName: 'StatisticSalesVolumeBySupplier',
      withPaginationWrapper: false,
      params: [
        { name: 'rangeType', type: 'StatisticTimeRange!' },
        { name: 'rangeStart', type: 'Date!' },
        { name: 'rangeEnd', type: 'Date' },
        { name: 'costCenterFilter', type: 'Int' },
        { name: 'supplierCode', type: 'Int' },
      ],
    },
    fieldDefinitions: fields,
  };
